export default {
  addTeam: 'Add team',
  hostnameRest: '.ohcompletely.com',
};
